import { defineAsyncComponent } from '../../lib/utils/vue3compat/vue.js?vue3';
import { GlBreadcrumb, GlButton, GlIcon, GlModalDirective, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { parseBoolean } from '@gitlab/frontend-utils';
import { __, s__ } from '~/locale';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import BrandLogo from './brand_logo.vue?vue3';
import { EVENT_OPEN_GLOBAL_SEARCH } from '~/vue_shared/global_search/constants';
import { staticBreadcrumbs } from '../../lib/utils/breadcrumbs_state.js?vue3';
import { RedirectScrollKeysToPanelDirective } from '~/vue_shared/directives/redirect_scroll_keys_to_panel';
import { adminRootPath } from '~/lib/utils/path_helpers/instance_admin';
import { newUserRegistrationPath, newUserSessionPath } from '~/lib/utils/path_helpers/routes';
import SuperSidebarToggle from './super_sidebar_toggle.vue?vue3';
import CreateMenu from './create_menu.vue?vue3';
import UserMenu from './user_menu.vue?vue3';
import UserCounts from './user_counts.vue?vue3';
import PromoMenu from './promo_menu.vue?vue3';
import { SEARCH_MODAL_ID } from './global_search/constants';
export default {
    name: 'SuperTopbar',
    SEARCH_MODAL_ID,
    staticBreadcrumbs,
    components: {
        GlButton,
        GlBreadcrumb,
        GlIcon,
        BrandLogo,
        SuperSidebarToggle,
        CreateMenu,
        UserCounts,
        UserMenu,
        PromoMenu,
        OrganizationSwitcher: defineAsyncComponent(()=>import(/* webpackChunkName: 'organization_switcher' */ './organization_switcher.vue?vue3')),
        SearchModal: defineAsyncComponent(()=>import(/* webpackChunkName: 'global_search_modal' */ './global_search/components/global_search.vue?vue3'))
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective,
        RedirectScrollKeysToPanel: RedirectScrollKeysToPanelDirective
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    i18n: {
        skipToMainContent: __('Skip to main content'),
        adminArea: s__('Navigation|Admin'),
        searchBtnText: __('Search or go to…'),
        analyticsDashboardsBtnText: s__('Analytics|View GitLab Intelligence')
    },
    inject: [
        'isSaas'
    ],
    provide () {
        return {
            showAdminAreaLink: this.showAdminButton
        };
    },
    props: {
        sidebarData: {
            type: Object,
            required: true
        }
    },
    computed: {
        isAdmin () {
            return parseBoolean(this.sidebarData?.admin_mode?.user_is_admin);
        },
        isLoggedIn () {
            return parseBoolean(this.sidebarData.is_logged_in);
        },
        allowSignUp () {
            return parseBoolean(this.sidebarData?.allow_signup);
        },
        shouldShowOrganizationSwitcher () {
            return this.glFeatures.orgSwitcher && this.isLoggedIn && window.gon.current_organization && this.sidebarData.has_multiple_organizations;
        },
        showAdminButton () {
            return this.isAdmin && (!this.sidebarData.admin_mode.admin_mode_feature_enabled || this.sidebarData.admin_mode.admin_mode_active);
        },
        // Supplied by EE only, and only when the feature flag is on. The route
        // itself is EE-only, so FOSS has no path helper to build it from.
        analyticsDashboardsPath () {
            return this.sidebarData.analytics_dashboards_path;
        }
    },
    methods: {
        adminRootPath () {
            return adminRootPath({
                organizationPath: null
            });
        },
        newUserRegistrationPath () {
            return newUserRegistrationPath({
                organizationPath: null
            });
        },
        signInPath () {
            return newUserSessionPath({
                redirect_to_referer: 'yes',
                organizationPath: null
            });
        },
        onSearchButtonDrop (event) {
            const text = event.dataTransfer.getData('text/plain');
            if (text) {
                document.dispatchEvent(new CustomEvent(EVENT_OPEN_GLOBAL_SEARCH, {
                    detail: {
                        searchText: text
                    }
                }));
            }
        }
    }
};
